/** Client for the intake wizard API (task 4170.2). */
import { apiFetch } from "../../app/api";

const BASE = "/api/v1/engagement-intake";

export interface IntakeState {
  engagement_id: string;
  opened: boolean;
  answers: Record<string, Record<string, unknown>>;
  missing: string[];
  ready: boolean;
}

export function message(caught: unknown): string {
  return caught instanceof Error ? caught.message : String(caught);
}

function url(id: string, path = ""): string {
  return `${BASE}/${encodeURIComponent(id)}${path}`;
}

function send(id: string, path: string, method: "POST" | "PUT", body: unknown): Promise<IntakeState> {
  return apiFetch<IntakeState>(url(id, path), { method, body: JSON.stringify(body) });
}

export function getIntake(id: string): Promise<IntakeState> {
  return apiFetch<IntakeState>(url(id));
}

export function openIntake(id: string, reason: string): Promise<IntakeState> {
  return send(id, "/open", "POST", { reason });
}

export function saveAnswer(id: string, path: string, body: unknown): Promise<IntakeState> {
  return send(id, path, "PUT", body);
}

export function confirmReady(id: string, reason: string): Promise<IntakeState> {
  return send(id, "/ready", "POST", { reason });
}
